enum ActionTypes {
  DELETE_BRAND = '@brand/DELETE_BRAND',
  GET_ALL_BRANDS = '@brand/GET_ALL_BRANDS',
  SAVE_BRAND = '@brand/SAVE_BRAND',
  UPDATE_BRAND = '@brand/UPDATE_BRAND',
}

export default ActionTypes
